export const BRAND_THEME = {
  All: { label: "All Brands", primary: "#4F46E5", bg: "#EEF2FF", text: "#3730A3" },
  "Nini's Kitchen": { label: "Nini's Kitchen", primary: "#EA580C", bg: "#FFF7ED", text: "#C2410C" },
  Niro: { label: "Niro", primary: "#0D9488", bg: "#F0FDFA", text: "#0F766E" },
  "Baked By Nini's": { label: "Baked By Nini's", primary: "#D97706", bg: "#FFFBEB", text: "#B45309" },
};

export const STATUS_STYLE = {
  Open: "bg-red-100 text-red-700 border-red-200",
  "In Progress": "bg-amber-100 text-amber-800 border-amber-200",
  Resolved: "bg-emerald-100 text-emerald-800 border-emerald-200",
  Closed: "bg-slate-100 text-slate-600 border-slate-200",
};

export const SEVERITY_STYLE = {
  High: "bg-red-50 text-red-700 border-red-200",
  Medium: "bg-amber-50 text-amber-700 border-amber-200",
  Low: "bg-slate-50 text-slate-600 border-slate-200",
};

export const SENTIMENT_COLOR = { Positive: "#10B981", Neutral: "#94A3B8", Negative: "#EF4444" };
export const STATUS_COLOR = { Open: "#EF4444", "In Progress": "#F59E0B", Resolved: "#10B981", Closed: "#94A3B8" };
export const PALETTE = ["#4F46E5", "#EA580C", "#0D9488", "#D97706", "#8B5CF6", "#EC4899", "#06B6D4", "#64748B", "#84CC16", "#F43F5E", "#0EA5E9"];

export const SOURCE_SHORT = { A: "Dine-in", B: "Online reviews", C: "Order complaints", D: "Calls & messages" };

export const EMPTY_FILTERS = {
  brand: [], outlet: [], source_type: [], platform: [], category: [], severity: [], status: [], sentiment: [], department: [],
  preset: "all", date_from: "", date_to: "", q: "",
};

const fmt = (d) => {
  const z = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${z(d.getMonth() + 1)}-${z(d.getDate())}`;
};

export function presetRange(preset) {
  const now = new Date();
  if (preset === "today") return [fmt(now), fmt(now)];
  if (preset === "7d") return [fmt(new Date(now.getTime() - 6 * 864e5)), fmt(now)];
  if (preset === "30d") return [fmt(new Date(now.getTime() - 29 * 864e5)), fmt(now)];
  if (preset === "this_month") return [fmt(new Date(now.getFullYear(), now.getMonth(), 1)), fmt(now)];
  if (preset === "last_month")
    return [fmt(new Date(now.getFullYear(), now.getMonth() - 1, 1)), fmt(new Date(now.getFullYear(), now.getMonth(), 0))];
  return ["", ""];
}

export function toParams(f) {
  const p = {};
  ["brand", "outlet", "source_type", "platform", "category", "severity", "status", "sentiment", "department"].forEach((k) => {
    if (f[k]?.length) p[k] = f[k].join("|");
  });
  if (f.date_from) p.date_from = f.date_from;
  if (f.date_to) p.date_to = f.date_to;
  if (f.q) p.q = f.q;
  return p;
}

export function fmtDate(d) {
  if (!d) return "—";
  const dt = new Date(d.length === 10 ? `${d}T00:00:00` : d);
  if (isNaN(dt)) return d;
  return dt.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
}

export function fmtDateTime(d) {
  if (!d) return "—";
  return new Date(d).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", timeZone: "Asia/Kolkata" });
}

export function timeAgo(d) {
  if (!d) return "never";
  const s = Math.round((Date.now() - new Date(d).getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.round(s / 60)} min ago`;
  if (s < 86400) return `${Math.round(s / 3600)} hours ago`;
  return `${Math.round(s / 86400)} days ago`;
}
